/**
 * Onglet du portail actif pour une adresse (01/11/2026) : l'adresse est l'un
 * des préfixes, ou commence par l'un d'eux suivi de « / » — `/compte` couvre
 * `/compte/mot-de-passe`, mais pas `/comptes`.
 */
export function ongletActif(prefixes: readonly string[], chemin: string): boolean {
  return prefixes.some((p) => chemin === p || chemin.startsWith(`${p}/`));
}
